<template>
  <el-row type="flex" style="width: 100%" class="arce-code-box">
    <area-code-default :area="area" @change="changeArea" class="marRight10" style="width: 120px;" :disabled="disabled"></area-code-default>
    <el-input v-model="phoneNum" class="flex1" type="text" size="small" placeholder="电话号码" @change="handleChange" :disabled="disabled"></el-input>
    <!-- <button v-if="phoneNum && disabled" class="copy-btn" type="button" @click="doCopy(phoneNum)">复制</button> -->
  </el-row>
</template>

<script>
import AreaCodeDefault from './AreaCodeDefault'
export default {
  name: 'AreaCode',
  props: {
    value: { // +86-15113990789,需要切割成
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AreaCodeDefault
  },
  data () {
    return {
      area: '+86',
      phoneNum: ''
    }
  },
  mounted () {
    
  },
  methods: {
    doCopy(txt) {
      let _this = this
      // console.log(txt)
      this.$copyText(txt).then(function (e) {
       _this.$message({
            message: '复制成功',
            type: 'success',
            duration:1200
          });
      }, function (e) {
        _this.$message({
            message: '复制失败',
            type: 'error',
            duration:1200
          });
      })
    },
    clear(){
      this.phoneNum = ''
    },
    handleChange (val) {
      if (val) {
        const _val = `${this.area}-${this.phoneNum}`
        console.log(_val)
        this.$emit('input', _val)
      } else {
        this.phoneNum = ''
        this.$emit('input', '')
      }
    },
    changeArea (val) {
      if (val) {
        this.area = val
        const _val = `${this.area}-${this.phoneNum}`
        this.$emit('input', _val)
      }
    }
  },
  watch: {
    value: {
      handler(val){
        if (val) {
          if (val.indexOf('-') !== -1) { // 当时拼接的时候
            const ary = val.split('-')
            this.area = ary[0]
            this.phoneNum = ary[1]
          } else {
            this.phoneNum = val
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.mobile-number {
  width: 120px;
  height: 32px;
  line-height: 32px;
  padding-left: 15px;
}
.copy-btn{
    display: inline-block;
    white-space: nowrap;
    margin-left: 10px;
    color: #289EFC;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/AreaCode/AreaCode.vue